import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  DOCUMENT_ATTACHMENTS__DOWNLOAD_FAILURE,
  DOCUMENT_ATTACHMENTS__DOWNLOAD_REQUEST,
  DOCUMENT_ATTACHMENTS__DOWNLOAD_SUCCESS,
  DOCUMENT_ATTACHMENTS__FETCH_FAILURE,
  DOCUMENT_ATTACHMENTS__FETCH_REQUEST,
  DOCUMENT_ATTACHMENTS__FETCH_SUCCESS,
  DOCUMENT_ATTACHMENTS__OPEN_FAILURE,
  DOCUMENT_ATTACHMENTS__OPEN_REQUEST,
  DOCUMENT_ATTACHMENTS__OPEN_SUCCESS,
} from '@app/store/actionTypes';
import Attachment from '@app/store/document/attachments/Attachment';
import File from '@app/store/document/attachments/File';
import { RequesterAttachment } from '@app/store/documentSetup/RequesterAttachment';

export function downloadAttachment(payload: {
  attachmentId: string;
  documentId: string;
  downloadFileName: string;
}) {
  return {
    type: DOCUMENT_ATTACHMENTS__DOWNLOAD_REQUEST,
    payload,
  };
}

export function downloadAttachmentSuccess(payload: { downloadFileName: string; file: File }) {
  return {
    type: DOCUMENT_ATTACHMENTS__DOWNLOAD_SUCCESS,
    payload,
  };
}

export function downloadAttachmentFailure(error: AxiosError) {
  return {
    type: DOCUMENT_ATTACHMENTS__DOWNLOAD_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchAttachments(payload: { documentId: string }) {
  return {
    type: DOCUMENT_ATTACHMENTS__FETCH_REQUEST,
    payload,
  };
}

export const fetchAttachmentsSuccess = createAction<
  {
    attachments: Attachment[];
    requesterAttachments: RequesterAttachment[];
  },
  typeof DOCUMENT_ATTACHMENTS__FETCH_SUCCESS
>(DOCUMENT_ATTACHMENTS__FETCH_SUCCESS);

export function fetchAttachmentsFailure(error: AxiosError) {
  return {
    type: DOCUMENT_ATTACHMENTS__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export function openAttachment(payload: { attachmentId: string; documentId: string }) {
  return {
    type: DOCUMENT_ATTACHMENTS__OPEN_REQUEST,
    payload,
  };
}

export function openAttachmentSuccess(payload: { file: { url: string } }) {
  return {
    type: DOCUMENT_ATTACHMENTS__OPEN_SUCCESS,
    payload,
  };
}

export function openAttachmentFailure({
  documentId,
  error,
}: {
  documentId: string;
  error: AxiosError;
}) {
  return {
    type: DOCUMENT_ATTACHMENTS__OPEN_FAILURE,
    payload: { documentId, error },
    error: true,
  };
}

export type DocumentAttachmentsAction =
  | ReturnType<typeof downloadAttachment>
  | ReturnType<typeof downloadAttachmentSuccess>
  | ReturnType<typeof downloadAttachmentFailure>
  | ReturnType<typeof fetchAttachments>
  | ReturnType<typeof fetchAttachmentsSuccess>
  | ReturnType<typeof fetchAttachmentsFailure>
  | ReturnType<typeof openAttachment>
  | ReturnType<typeof openAttachmentSuccess>
  | ReturnType<typeof openAttachmentFailure>;
